import React from "react";

import { Row, Col } from "antd";
import PropTypes from "prop-types";

const OpeningHours = ({ data }) => (
  <>
    <Row gutter={[16, 8]}>
      <Col>
        {data.map(({ day }) => (
          <Col key={`openingHours-days:${day}`}>{day}:</Col>
        ))}
      </Col>
      <Col>
        {data.map(({ openingTimes }) => (
          <Col key={`openingHours-times:${openingTimes}`}>{openingTimes}</Col>
        ))}
      </Col>
    </Row>
  </>
);

OpeningHours.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string.isRequired,
      openingTimes: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default OpeningHours;
